var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mail-detail-integration" } },
    [
      _c("div", { staticClass: "integrations" }, [
        _c("span", { staticClass: "fix-align" }, [
          _c("span", { staticClass: "img" }, [_c("MailIcon")], 1),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "forwards" },
        [
          _c(
            "div",
            {
              staticClass: "forward forward-add",
              on: {
                click: function ($event) {
                  return _vm.gmailIntegration(true)
                },
              },
            },
            [
              _c("a-icon", {
                staticStyle: { "font-size": "30px" },
                attrs: { type: "plus-circle", theme: "filled" },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "text-large font-weight-bolder mt-2",
                  staticStyle: { "font-size": "15px" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s("Yeni Ekle") +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.forwardAddresses, function (forwardAddress) {
            return _c(
              "div",
              { staticClass: "forward-item" },
              [
                _c(
                  "div",
                  { staticClass: "icon-container" },
                  [
                    _c("MailIcon", {
                      staticStyle: { width: "40px", height: "40px" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("a-tooltip", { attrs: { title: forwardAddress.mail } }, [
                  _c("span", { staticClass: "forward-mail-address" }, [
                    _vm._v(_vm._s(forwardAddress.mail)),
                  ]),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "integrations" }, [
        _c("span", { staticClass: "fix-align" }, [
          _c("span", { staticClass: "img" }, [_c("MicrosoftIcon")], 1),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "forwards" },
        [
          _c(
            "div",
            {
              staticClass: "forward forward-add",
              on: {
                click: function ($event) {
                  return _vm.gmailIntegration(false)
                },
              },
            },
            [
              _c("a-icon", {
                staticStyle: { "font-size": "30px" },
                attrs: { type: "plus-circle", theme: "filled" },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "text-large font-weight-bolder mt-2",
                  staticStyle: { "font-size": "15px" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s("Yeni Ekle") +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.microsoftForwardAddresses, function (forwardAddress) {
            return _c(
              "div",
              { staticClass: "forward-item" },
              [
                _c(
                  "div",
                  { staticClass: "icon-container" },
                  [
                    _c("MailIcon", {
                      staticStyle: { width: "40px", height: "40px" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("a-tooltip", { attrs: { title: forwardAddress.mail } }, [
                  _c("span", { staticClass: "forward-mail-address" }, [
                    _vm._v(_vm._s(forwardAddress.mail)),
                  ]),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "testModal2",
          attrs: { title: "Yönlendirme Adımları", centered: "" },
          on: { ok: _vm.closeModal },
          model: {
            value: _vm.isGmailIntegration,
            callback: function ($$v) {
              _vm.isGmailIntegration = $$v
            },
            expression: "isGmailIntegration",
          },
        },
        [_c("div", [_c("gif-player", { attrs: { src: _vm.getGifSrc() } })], 1)]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("div", { staticClass: "integration-name" }, [
        _vm._v("Google(Gmail) Forward"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("div", { staticClass: "integration-name" }, [
        _vm._v("Microsoft (Outlook/Exchange) Forward"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }